import { useState } from 'react';
import { Icon } from '../Icon.jsx';

export function PasswordField({ id, value, onChange, label = 'Password', autoComplete = 'current-password', minLength, placeholder = 'Enter your password', hint }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="password-input">
        <input id={id} type={visible ? 'text' : 'password'} autoComplete={autoComplete} minLength={minLength} required value={value} onChange={onChange} placeholder={placeholder} />
        <button type="button" className="password-input__toggle" aria-label={visible ? 'Hide password' : 'Show password'} aria-pressed={visible} onClick={() => setVisible((current) => !current)}>
          <Icon name={visible ? 'eyeOff' : 'eye'} size={18} />
        </button>
      </div>
      {hint && <span className="field-hint">{hint}</span>}
    </div>
  );
}
